
export const locator = (parent = '', data = '', mode = '') => {
  let locator = [];
  let result;
  Boolean(parent) && locator.push(parent);
  Boolean(data) && locator.push(data);
  result = locator.join('.');
  Boolean(mode) && (result = `${result}[${mode}]`);
  return result;
};
